import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './app/App.tsx';
import { AuthProvider } from './features/auth/AuthContext.tsx';
import { JiraRelayBootstrap } from './features/jira/JiraRelayBootstrap.tsx';
import { ThemeProvider } from './shared/theme/ThemeProvider.tsx';
import { applyTableFontSize } from './shared/prefs/store.ts';
import 'antd/dist/reset.css';
import './shared/styles/fonts.ts';
import './shared/styles/global.css';

// Применяем размер шрифта таблиц из localStorage-кэша до первого рендера,
// чтобы не было мигания при перезагрузке (серверное значение догонит при гидрации).
applyTableFontSize();

const container = document.getElementById('root');
if (!container) {
  throw new Error('root container not found');
}

ReactDOM.createRoot(container).render(
  <React.StrictMode>
    <ThemeProvider>
      <BrowserRouter>
        <AuthProvider>
          <JiraRelayBootstrap />
          <App />
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>,
);
